// OPT-310: keeps state.accounts current while the app is open. An account
// added outside this tab (the Session Sync extension's "Add to Sellary")
// shows up when the tab regains focus, without signing out. One refresh runs
// at a time; focus refreshes are at most one per `minGapMs`; a failed one
// keeps the last list (refreshAccounts never commits on failure) and is
// retried once after `retryMs`; the retry itself is not retried. After
// stop() nothing runs.
export function createAccountsRefresher(dispatch, {
  now = () => Date.now(),
  setTimer = (fn, ms) => setTimeout(fn, ms),
  clearTimer = (t) => clearTimeout(t),
  minGapMs = 30000,
  retryMs = 15000,
} = {}) {
  let last = -Infinity;
  let retry = null;
  let inFlight = null;
  let stopped = false;

  function refresh(force = false, isRetry = false) {
    if (stopped) return Promise.resolve(null);
    if (inFlight) return inFlight;
    if (!force && now() - last < minGapMs) return Promise.resolve(null);
    last = now();
    clearTimer(retry);
    retry = null;
    inFlight = Promise.resolve()
      .then(() => dispatch("refreshAccounts"))
      .then(
        () => true,
        () => {
          // One retry per refresh that was asked for, not a retry chain.
          if (!stopped && !isRetry) retry = setTimer(() => refresh(true, true), retryMs);
          return false;
        }
      )
      .finally(() => {
        inFlight = null;
      });
    return inFlight;
  }

  return {
    refresh: (force = false) => refresh(force),
    stop: () => {
      stopped = true;
      clearTimer(retry);
      retry = null;
    },
  };
}
